module.exports = __webpack_public_path__ + "static/black-elk-speaks-19fe7f331c3d8f666183de6d1d3fbab0.jpg";